<mat-drawer-container hasBackdrop="true" class="case-drawer-container">
  <mat-drawer #caseDrawer mode="over" class="case-drawer" style="height: fit-content">
    <mat-card appearance="outlined" class="card-primary">
      <button mat-icon-button class="close-button" (click)="closeCaseDrawer()">
        <mat-icon>clear</mat-icon>
      </button>
      @if (selectedCaseId && selectedCaseId !== '') {
        <app-case [padding-top]="false" [hide-iframe]="true" [id]="selectedCaseId"> </app-case>
      }
      @if (!selectedCaseId) {
        <div class="select-case-first-box">
          <p>{{ 'case.select-case-on-dashboard' | translate | capitalize }}</p>
        </div>
      }
    </mat-card>
  </mat-drawer>
  <mat-drawer-content></mat-drawer-content>
</mat-drawer-container>
